<div *ngIf="row.importResult && !row.description; else normalDesc">
  {{
    'csvImport.saveCart.importDesc'
      | cxTranslate: { importRef: row.importResult.importRef, importSuccess: row.importResult.importSuccess }
  }}
  <span *ngIf="row.importResult.importFailed">
    {{ 'csvImport.saveCart.importDescFailed' | cxTranslate }}
    <button class="tertiary-btn btn js-saved-cart-desc-error" style="height: auto" (click)="openError(row.code)">
      {{ 'csvImport.saveCart.importDescFailedNumber' | cxTranslate: { importFailed: row.importResult.importFailed } }}
    </button>
  </span>
</div>
<ng-template #normalDesc>
  <div class="cart-list-description" [innerText]="row.description"></div>
</ng-template>
